export var inmateNotification = function inmateNotification(centralApi) {
  return {
    post: function post(data) {
      return centralApi.post('/inmate-notification', data);
    },
    delete: function _delete(id) {
      return centralApi.delete("/inmate-notification/".concat(id));
    }
  };
};